import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MicrosoftTeamsCallForwardingSettingsFieldConfig } from '../../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class TeamsCallForwardingSettingsFieldConfigResource {
  private http = inject(HttpClient);

  get(tenantId: string | number, dialPlanId: number): Observable<MicrosoftTeamsCallForwardingSettingsFieldConfig> {
    return this.http.get<MicrosoftTeamsCallForwardingSettingsFieldConfig>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/teams-calling-forwarding-settings/${dialPlanId}`,
    );
  }
}
